export default {
  user: (state, getters) => getters.isImpersonating ? state.impersonatedUser : state.user,
  isImpersonating: state => state.impersonatedUser !== null,
  userImpersonator: (state, getters) => getters.isImpersonating ? state.user : null,
  isAuthenticated: state => state.token !== null,
  refreshTokenTimer: state => state.refreshTokenTimer,
  isCallingLogin: state => state.isCallingLogin,
  loggedUserRoles: (state, getters) => {
    if (getters.isImpersonating) {
      return state.impersonatedUser && state.impersonatedUser.roles ? state.impersonatedUser.roles : false
    } else {
      return getters.user && getters.user.roles ? getters.user.roles : false
    }
  },
  adminRoles: () => ['ROLE_ADMIN', 'ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER'],
  adminOwnerRoles: () => ['ROLE_ADMIN_OWNER', 'ROLE_ACCOUNT_HOLDER'],
  superAdminRoles: () => ['ROLE_SUPER_ADMIN', 'ROLE_COMMERCIAL'],
  commercialRoles: () => ['ROLE_COMMERCIAL'],
  accountingRoles: () => ['ROLE_BOOKKEEPER'],
  normalUserRoles: () => ['ROLE_REGULAR'],
  superBookKeeperRoles: () => ['ROLE_SUPER_BOOKKEEPER'],

  isSuperAdmin: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.superAdminRoles.includes(el))
  },

  isAdmin: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.adminRoles.includes(el))
  },
  isCommercial: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.commercialRoles.includes(el))
  },
  isBookKeeper: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.accountingRoles.includes(el))
  },
  isUser: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.normalUserRoles.includes(el))
  },
  isOwnerOfAnyBudget: (state, getters) => {
    return getters.user.isOwnerOfAnyBudget
  },
  isReviewer: (state, getters) => {
    return getters.user.isReviewer
  },
  isSuperBookKeeper: (state, getters) => {
    if (!getters.user || !getters.user.roles) {
      return false
    }
    const roles = getters.user.roles
    return roles.some(el => getters.superBookKeeperRoles.includes(el))
  },
  loggedUserId: (state) => {
    if (state.impersonatedUser) {
      return state.impersonatedUser.id
    }
    return state.user && state.user.user_id ? state.user.user_id : false
  },
  errors: state => state.errors

}
